import React, { Component, createRef } from 'react'
import { withCookies } from "react-cookie"
import { Map as LeafletMap, TileLayer } from 'react-leaflet'

class MapBackground extends Component {

    mapInstTimeout = null;

    constructor(props){
        super(props);
        let center = [0,0]
        if (this.props.center) {
            center = this.props.center
        } else if (this.props.cookies.cookies.latlong) {
            center = this.props.cookies.cookies.latlong.split(',')
        }
        this.state = {
            center: center,
            zoom: ( this.props.zoom ? this.props.zoom : 13 )
        }
        this.map = createRef();
    }

    // componentDidMount(prevProps) {
    //     this.mapInst = this.map.current.leafletElement
    //     this.mapInst.attributionControl.setPrefix(false)
    //     this.mapInst.whenReady(() => this.mapInstTimeout = setTimeout(
    //         () => {
    //             this.mapInst.invalidateSize()

    //             fetch(configLoader.ApiGeo, {
    //                 method: 'GET',
    //                 headers: {
    //                     'Accept': 'application/json',
    //                     'Content-Type': 'application/json',
    //                 }
    //             }).then(response => {
    //                 if (response.status !== 200)
    //                     throw response.status;
    //                 else
    //                     return response.json()
    //             }).catch(error => console.log("IP geo-lookup error:", error))
    //                 .then(data => {
    //                     if (data) {
    //                         this.mapInst.setView({ lat: data.latitude, lng: data.longitude }, 11)
    //                     }
    //                 }).catch(error => console.log(error))
    //         }, 10)
    //     )

    // }

    // componentWillUnmount() {
    //     if (this.mapInstTimeout)
    //         clearTimeout(this.mapInstTimeout)
    // }

    render() {
        return (
            <LeafletMap
                onViewportChanged={ this.props.onViewportChanged }
                center={ this.state.center }
                zoom={ this.state.zoom }
                ref={this.map}
                className={this.props.className}
                {...this.props}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                />
                { this.props.children }
            </LeafletMap>
        );
    }
}
export default withCookies(MapBackground)